import slice from './slice';

const { reducer } = slice;
export { reducer as MapReducer }; 

export * from './actions';
export * from './selectors';